
export interface IFleetParamBase {	 		
	missionIds:Array<number>	//Liste des missions de la flotte	
	//Liste des missions de la flotte ayant participé à un moment donnée à la flotte	
	

	freeMissionIds:Array<number>
	associationIds:Array<number>	

	manager:string,	
	phone:string,	

	argos:Record<number,string>

	missionHisto:Array<{misId:number,startDate:string,endDate:string|null}>	
	start_date:string|null
	end_date:string|null	
}


export function getDefaultFleetParamBase({missionIds=[],freeMissionIds=[],associationIds=[],missionHisto=[],start_date=null,end_date=null,manager='',phone='',argos={}}={}):IFleetParamBase {
	return {		
		missionIds,
		freeMissionIds,
		missionHisto,
		start_date,
		end_date,
		manager,
		phone,
		argos,
		associationIds
	} 
}